import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useState, ReactNode } from "react";


interface AccordionProps {
    title: string;
    children: ReactNode;
    defaultOpen?: boolean;
}


export const Accordion: React.FC<AccordionProps> = ({ title, children, defaultOpen = true }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="select-none py-1 md:py-2">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="text-md font-medium capitalize my-2 md:my-3">{title}</div>
                <div className="flex">
                    {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
            </div>
            <div
                className="grid transition-all duration-500 ease-in-out"
                style={{
                    overflow: 'hidden',
                    gridTemplateRows: isOpen ? '1fr' : '0fr',
                }}
            >
                <div className="overflow-hidden">
                    <div className="flex flex-col gap-3">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}